<template>
  <div>
    <!-- Load consent web component -->
    <script
      type="application/javascript"
      src="https://rekomlifestorageprod.blob.core.windows.net/crm/consent.js"
    />

    <vue-recaptcha
      @verify="onVerify"
      @error="onCaptchaError"
      @expired="onCaptchaError"
      ref="recaptcha"
      sitekey="6LeXBncjAAAAAOyHXYUw-8SOgWVk0ojbhE9KQFWT"
      size="invisible"
    ></vue-recaptcha>

    <div
      class="flex justify-center items-start h-screen md:pt-24"
      v-if="hasLoaded"
    >
      <div
        @click.stop="closeModal(true)"
        class="btn-popup-close cursor-pointer"
      >
        <img src="../../../assets/images/cancel_btn.png" />
      </div>
      <div @click.stop>
        <!-- Class rekom-dynamic-form is important for tracking -->
        <form
          :action="apiConfig.postUrl()"
          ref="form"
          method="POST"
          @submit="onSubmit"
          :id="formId"
          class="rekom-dynamic-form"
        >
          <input type="hidden" name="recaptchaToken" :value="recaptchaToken" />
          <input type="hidden" name="venueId" :value="venueId" />
          <input type="hidden" name="formId" :value="formId" />
          <div
            ref="wrapper"
            :class="{ visible: !showingThankyou }"
            class="dynamic-form-wrapper"
            v-html="formHtml"
          ></div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import { VueRecaptcha } from "vue-recaptcha";
export default {
  components: {
    VueRecaptcha,
  },
  props: {},
  data() {
    return {
      apiConfig: {
        getUrl: (venueId, formId) =>
          `https://rekom-crm-functions-prod.azurewebsites.net/api/GetDynamicForm?code=fCA0q0fcQHvxTLolC7SBToFIbdeRgmeLB12BB3DdpKF2AzFuNH_W9A==&venueId=${venueId}&formId=${formId}`,
        postUrl: () =>
          "https://rekom-crm-functions-prod.azurewebsites.net/api/DynamicFormsFormSubmitted?code=q2BBstwlFWGeSYMO88w3Jtxitinaf1CajvJeGVcQZ/2D03kFxSdfQg==",
      },

      // Inputs
      venueId: "",
      formId: "",

      // Used
      hasLoaded: false,
      formHtml: "",
      showingThankyou: false,
      recaptchaToken: null,

      // Analytics
      venueCountry: "",
      venueName: "",
      formName: "",
      analyticsDetails: null,
      hasInjectedAnalytics: false,
    };
  },
  methods: {
    async onCaptchaError(err) {
      console.log("Captcha error", err);
    },
    injectScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", resolve);
        script.addEventListener("error", (e) => reject(e.error));
        document.head.appendChild(script);
      });
    },

    closeModal(sendTrackingEvent) {
      try {
        if (sendTrackingEvent) {
          window.parent.postMessage(
            JSON.stringify({
              action: "dynamicForm_gtmTrackCustomEvent",
              eventData: {
                ga_event_name: "dynamic_form_closed",
                item_id: this.formId,
                item_name: this.formName,
                event_category: "dynamic form",
                event_label: "Dynamic form closed",
              },
            }),
            "*"
          );
        }
      } finally {
        window.parent.postMessage(
          JSON.stringify({ action: "closeDynamicForm" }),
          "*"
        );
      }
    },
    setVenueStyle(venueStyle) {
      // Set venue colors
      this.$nextTick(() => {
        const bodies = this.$refs.wrapper.querySelectorAll(".u_body");
        bodies.forEach((body) => {
          body.style.setProperty(
            "background-color",
            venueStyle.colorBackground,
            "important"
          );
          body.style.setProperty("color", venueStyle.colorFont, "important");
        });

        const ctas = this.$refs.wrapper.querySelectorAll(
          "input[type=submit], .u_content_button a"
        );
        ctas.forEach((cta) => {
          cta.style.setProperty(
            "background-color",
            venueStyle.colorPrimaryCta,
            "important"
          );
          cta.style.setProperty(
            "color",
            venueStyle.colorPrimaryCtaFont,
            "important"
          );
        });
      });
    },

    showThankyou() {
      let node = document.createElement("div");
      node.innerText = "Thank you.";
      node.className = "thank-you-element";
      this.$refs.wrapper.appendChild(node);
      this.showingThankyou = true;
    },

    setProperties(newHtml, venueStyle) {
      this.formHtml = newHtml;
      this.setVenueStyle(venueStyle);
    },

    onSubmit(e) {
      console.log("Submitted dynamic form", e);

      // Query all consents within this form, and check their status
      const consents = this.$el.querySelectorAll("rekom-dynamic-form-consent");

      this.$nextTick(() => {
        consents.forEach((consentElem) => {
          const vueComp = consentElem.getVueInstance();

          // If required but no given consent
          if (vueComp.required && !vueComp.consent) {
            e.preveventDefault();
            vueComp.flashInvalid();
            return false;
          }
        });
      });

      e.preventDefault();

      this.$refs.recaptcha.execute();
    },

    async onVerify(token) {
      this.recaptchaToken = token; // Also sets the hidden field of the form
      console.log("Recaptcha verified", this.recaptchaToken);

      window.parent.postMessage(
        JSON.stringify({
          action: "dynamicForm_gtmTrackCustomEvent",
          eventData: {
            ga_event_name: "dynamic_form_submitted",
            item_id: this.formId,
            item_name: this.formName,
            event_category: "dynamic form",
            event_label: "Dynamic form submitted",
            value: 100,
            currency: "DKK",
          },
        }),
        "*"
      );

      this.showThankyou();
      setTimeout(() => {
        this.active = false;
        this.closeModal(false);
      }, 2400);

      // Submitting form on next tick
      this.$nextTick(() => {
        console.log("Submitting verified form. Token: ", this.recaptchaToken);
        this.$refs.form.submit();
      });
    },
  },
  async created() {
    this.venueId = this.$route.query.venueId;
    this.formId = this.$route.query.formId;

    console.log("VenueId", this.venueId, "FormId", this.formId);

    try {
      const resp = await fetch(
        this.apiConfig.getUrl(this.venueId, this.formId)
      );
      const data = await resp.json();
      console.log("returned data", data);
      document.title = "Dynamic form | REKOM forms";

      this.venueCountry = data.venueCountry;
      this.venueName = data.venueName;
      this.analyticsDetails = data.analyticsDetails;
      this.formName = data.formName;

      window.parent.postMessage(
        JSON.stringify({
          action: "dynamicForm_gtmTrackCustomEvent",
          eventData: {
            ga_event_name: "dynamic_form_opened",
            item_id: this.formId,
            item_name: this.formName,
            event_category: "dynamic form",
            event_label: "Dynamic form opened",
          },
        }),
        "*"
      );

      this.hasLoaded = true;
      this.setProperties(data.formHtml, data.venueStyle);
    } catch (err) {
      console.error("Error fetching dynamic form", err);
      this.closeModal(false);
    }
  },
};
</script>

<style lang="scss">
@import "../../../assets/css/_unlayerBaseStyling.scss";

.grecaptcha-badge {
  visibility: hidden;
}

body {
  background-color: rgba(0, 0, 0, 0.5);
  // backdrop-filter: blur(2px);
}

.btn-popup-close {
  top: 1.5rem;
  right: 1.5rem;
  position: absolute;
  z-index: 1;
}
.btn-popup-close:hover {
  opacity: 0.75;
}
.btn-popup-close-relative img {
  vertical-align: middle;
  object-fit: cover;
  height: 30px;
  width: auto;
}
.btn-popup-close img {
  object-fit: cover;
  height: 30px;
  width: auto;
}

.dynamic-form-wrapper {
  .thank-you-element {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #fff;
    text-shadow: 0px 0px 20px #000;
  }
}
</style>